<template>
  <v-autocomplete
    :model-value="modelValue"
    @update:model-value="value => $emit('update:model-value', value)"
    :items="roles"
    v-bind="{ ...$props, ...$attrs }"
    item-title="text"
    :label="$t('user.forms.editUserForm.labels.userRole')">
    <template v-slot:item="{ item, props }">
      <v-list-item
        v-bind="props"
        :title="item.raw.text"
        :subtitle="item.raw.description"></v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
/**
 * Role Select
 * @displayName Role Select
 */
export default {
  props: {
    /**
     * @model
     */
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * Current user's role
     */
    parentRole: {
      type: String,
      required: false
    },
    /**
     * Roles to exclude
     */
    excludedRoles: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    roles: []
  }),
  computed: {
    computedRoles() {
      return Object.values(this.novaCore.UserRole)
        .filter(
          role =>
            (!this.parentRole || this.novaCore.isUserRoleLessOrEqual(role, this.$me.role)) &&
            !this.excludedRoles.includes(role)
        )
        .map(value => ({
          value,
          text: this.novaCore.userRoleToText(value),
          description: this.novaCore.getTranslatedUserRoleDescription(value)
        }));
    }
  },
  mounted() {
    this.roles = this.computedRoles;
  }
};
</script>
